import Model from '@/models/Model.js';

export default class LtiResourceLinkActivity extends Model {
    static entity = 'lti_resource_link_activities';

    static modelName = 'LtiResourceLinkActivity';

    static fields() {
        return {
            id: this.attr(null),
            content_template_id: this.attr(null),
            lti_resource_link_id: this.attr(null),
            content: this.attr(null),

            ...super.fields(),

            content_template: this.belongsTo('lti_resource_link_activity_templates', 'content_template_id'),
            ltiResourceLink: this.belongsTo('lti_resource_links', 'lti_resource_link_id'),
            activity: this.morphOne('activities', 'contentable_id', 'contentable_type_entity'),
        };
    }
}
